import styled from 'styled-components';

const ICON_SIZE = 32;

export const Root = styled.div`
  min-height: ${ICON_SIZE}px;
  margin-bottom: ${({ theme }) => theme.spacings.abs32}px;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
`;

export const CloseButtonContainer = styled.div`
  flex-grow: 1;
`;
